// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_alert_state_enum */
var FermentationAlertStateEnum;
(function (FermentationAlertStateEnum) {
    FermentationAlertStateEnum["RAISED"] = "RAISED";
    FermentationAlertStateEnum["ACKED"] = "ACKED";
    FermentationAlertStateEnum["CLEARED"] = "CLEARED";
})(FermentationAlertStateEnum || (FermentationAlertStateEnum = {}));
;
export default FermentationAlertStateEnum;
/** Zod schema for fermentation_alert_state_enum */
export const fermentationAlertStateEnum = z.nativeEnum(FermentationAlertStateEnum);
//# sourceMappingURL=FermentationAlertStateEnum.js.map